import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/context/ProtectedRoute";
import PublicLanding from "@/pages/PublicLanding";
import Confirmation from "@/pages/Confirmation";
import PaymentReturn from "@/pages/PaymentReturn";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Today from "@/admin/Today";
import Clients from "@/admin/Clients";
import ClientDetail from "@/admin/ClientDetail";
import CalendarView from "@/admin/CalendarView";
import Settings from "@/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<PublicLanding />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/payment/return" element={<PaymentReturn />} />
          <Route path="/payment/success" element={<PaymentReturn />} />
          <Route path="/payment/cancel" element={<PaymentReturn />} />
          <Route path="/payment/error" element={<PaymentReturn />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Today />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="calendrier" element={<CalendarView />} />
            <Route path="reglages" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
